import { render, staticRenderFns } from "./NewTableView.vue?vue&type=template&id=42805c9c&scoped=true&"
import script from "./NewTableView.vue?vue&type=script&lang=js&"
export * from "./NewTableView.vue?vue&type=script&lang=js&"
import style0 from "./NewTableView.vue?vue&type=style&index=0&id=42805c9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42805c9c",
  null
  
)

export default component.exports